import { useCallback } from "react";
import { useQuery } from "@apollo/client";
import { FETCH_OFFER_STATUSES } from "../graphql/query/OfferStatus";

const useOfferStatus = () => {
  const { data = {}, loading, error } = useQuery(FETCH_OFFER_STATUSES);

  const findOfferStatusById = useCallback(
    id => {
      return data?.offerStatuses?.find(status => status.id === id);
    },
    [data],
  );

  const findOfferStatusByDescription = useCallback(
    description => {
      return data?.offerStatuses?.find(
        status => status.description === description,
      );
    },
    [data],
  );

  return {
    error,
    loading,
    offerStatuses:
      data?.offerStatuses?.map(status => ({
        id: status.id,
        description: status.description,
      })) || [],
    findOfferStatusById,
    findOfferStatusByDescription,
  };
};

export default useOfferStatus;
